"use client";

import { useState, useEffect } from "react";
import Image from "next/image";
import { resolveEventImage, pickEventFallbackImageAlt } from "@/lib/eventImage";

export default function EventCoverImage({
  eventId,
  rawImage,
  baseUrl,
  alt,
  className = "",
  sizes,
  priority,
  quality,
  unoptimized,
}) {
  const initial = resolveEventImage(rawImage, baseUrl, eventId);
  const [src, setSrc] = useState(initial);

  useEffect(() => {
    setSrc(resolveEventImage(rawImage, baseUrl, eventId));
  }, [rawImage, baseUrl, eventId]);

  return (
    <Image
      src={src}
      alt={alt}
      fill
      className={className}
      sizes={sizes}
      priority={priority}
      quality={quality}
      unoptimized={typeof unoptimized === "boolean" ? unoptimized : /^data:/i.test(String(src || ""))}
      onError={() => setSrc(pickEventFallbackImageAlt(eventId))}
    />
  );
}
